module.exports = __webpack_public_path__ + "poster6.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster6.png
// module id = 1136
// module chunks = 10